export const GET_GEOLOCATION_V2 = "GET_GEOLOCATION_V2";
export const GET_GEOLOCATION_V2_PENDING = "GET_GEOLOCATION_V2_PENDING";
export const GET_GEOLOCATION_V2_REJECTED = "GET_GEOLOCATION_V2_REJECTED";
export const GET_GEOLOCATION_V2_FULFILLED = "GET_GEOLOCATION_V2_FULFILLED";
